import { useCallback, useEffect, useState } from "react"

import { LoaderCircle } from "lucide-react"
import { Row, Col, Label, FormGroup, Button, Input, SelectMulti, FormFeedback, SimpleAlert, SheetFooter, SheetBody } from "twyne-new.ui"

import { useBuilderBlocksStore } from "../store";

export default function BuilderBlocksForm({ data, onSubmit, onCancel }) {
  const { loading, lists: { tags: { useLoad, items } } } = useBuilderBlocksStore()

  const [tagOptions, setTagOptions] = useState([])
  const [error, setError] = useState({})

  const [name, setName] = useState("")
  const [tags, setTags] = useState([])

  const validate = useCallback(() => {
    if (!name) {
      setError({ name: "Name is required" })
      return false
    }

    return true
  }, [name])

  const handleName = useCallback(event => {
    setName(event.target.value)
    setError({})
  }, [])

  const handleSubmit = useCallback(async () => {
    if (!validate()) {
      return;
    }

    await onSubmit({
      ...data,
      name,
      tags: tags.map(tag => tag.value),
    })
  }, [data, onSubmit, validate, name, tags])

  useLoad()

  useEffect(() => {
    if (items.length) {
      setTagOptions(items.map(({ tag }) => ({ value: tag, label: tag })))
    }
  }, [items])

  useEffect(() => {
    if (data) {
      setName(data.name)
      setTags(data.tags?.map(tag => ({ value: tag, label: tag })))
    }
  }, [data])

  return <>
    <SheetBody>
      <Row>
        <Col size="12">
          <FormGroup>
            <Label>Name</Label>
            <Input name="name" value={name} onChange={handleName} error={error.name} required />
            {error.name && <FormFeedback>{error.name}</FormFeedback>}
          </FormGroup>
        </Col>
        <Col size="12">
          <FormGroup>
            <Label>Tags</Label>
            <SelectMulti value={tags} options={tagOptions} onChange={setTags}
              placeholder="Type to create a tag" creatable />
          </FormGroup>
        </Col>
        {error.save ? <Col size="12">
          <SimpleAlert className="m-0 py-2 px-3" variant="danger">{error.save}</SimpleAlert>
        </Col> : null}
      </Row>
    </SheetBody>
    <SheetFooter>
      <Button color="neutral" variant="ghost" onClick={onCancel}>
        Cancel
      </Button>
      <Button color="accent" onClick={handleSubmit} disabled={loading}>
        {loading ? <LoaderCircle className="animate-spin" size={16} /> : "Save"}
      </Button>
    </SheetFooter>
  </>
}
